import { useLayoutEffect } from 'react';

import { RestoreStyle } from '../types/RestoreStyle';

// A modal <dialog> leaves the page behind it scrollable, so the lock is ours to apply
export const useScrollLock = (): void => {
  useLayoutEffect((): (() => void) => {
    const { body, documentElement } = document;
    const restoreStyles: RestoreStyle[] = [];
    const scrollbarSize = window.innerWidth - documentElement.clientWidth;

    // Pad the body by the scrollbar it is about to lose, so the page does not shift
    if (scrollbarSize > 0) {
      restoreStyles.push({
        element: body,
        property: 'padding-right',
        value: body.style.paddingRight,
      });

      const paddingRight = parseFloat(getComputedStyle(body).paddingRight) || 0;

      body.style.paddingRight = `${paddingRight + scrollbarSize}px`;
    }

    const scrollContainer =
      getComputedStyle(documentElement).overflowY === 'scroll'
        ? documentElement
        : body;

    ['overflow', 'overflow-x', 'overflow-y'].forEach((property): void => {
      restoreStyles.push({
        element: scrollContainer,
        property,
        value: scrollContainer.style.getPropertyValue(property),
      });
    });

    scrollContainer.style.overflow = 'hidden';

    return (): void => {
      restoreStyles.forEach(({ element, property, value }): void => {
        if (value) {
          element.style.setProperty(property, value);
        } else {
          element.style.removeProperty(property);
        }
      });
    };
  }, []);
};
